import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IApplicationPayment, IApplicationPaymentInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationPaymentApiService {

  abstract getApplicationPayment(applicationId: string): Observable<IApplicationPayment>;

  abstract updateApplicationPayment(applicationPayment: IApplicationPaymentInput, applicationPaymentId: string | ''): Observable<any>;
}